import * as types from "./types";

/** `list` holds the raw `data` array of GET /activity_logs (PROLINE-3943). */
const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
  loading: false,
};

const activityLogs = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ACTIVITY_LOGS_REQUEST:
      return { ...state, loading: true };
    case types.GET_ACTIVITY_LOGS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
        loading: false,
      };
    // Clear the list: the previous results don't match the new filters / page.
    case types.GET_ACTIVITY_LOGS_FAILURE:
      return { ...initialState };
    default:
      return state;
  }
};

export default activityLogs;
